//TODO The trash delete through 30 day.

function tablePresent(){
	var fn = function(){
		$('.table-present:not(.j-send-request) td').each(function() {
			var trHeight = $(this).height();
			if((trHeight-24) > 0) {
				$(this).find("p").height(trHeight-24);
			}
		});
	}
	require(['Controls/Responsive'], function (obResponsive) {
		if (obResponsive.getCurType() == 'large') {
			fn();
		} else {
			obResponsive.one('large', 'in', fn);
		}
	});
}

function ajaxPost(){
	$.ajax ({
		type : 'post',
		dataType: 'json',
		complete : function (response) {
			/*var formData = $(".j-form").serialize();*/
			$(".j-required").removeClass("error");
			$(".j-required, .j-email").parent().removeClass("error");
			$(".j-required, .j-email").parent().removeClass("error-email");
			$(".j-required").each(function() {
				if($(this).hasClass("j-select")) {
					if($(this).find("input:hidden").val() == 0) {
						$(this).addClass("error");
					}
				} else {
					if($(this).val() == "") {
						$(this).parent().addClass("error");
					}
				}
			});
			$(".j-email").each(function() {
				if($(this).val() != "") {
					if(!emailValidate($(this).val())){
						$(this).parent().addClass("error");
						$(this).parent().addClass("error-email");
					}
				}
			});
		}
	});
}

$(document).on("click", ".j-submit", function() {
	ajaxPost();
});
$(document).on("click", ".j-submit2", function() {
	$(this).parentsUntil("form").parent().submit();
});
$(".j-file").click(function() {
	$(this).find("input").trigger("click");
	return false;
});
$('.close-action').click(function(){
	$(this).parents('.action-item ').hide();
	return false;
});
$('.why-we-block').each(function () {
	var first_block = $(this).find('.why-we-links:first');
	var first_link = $(this).find('.why-we-links:first').find('li:first');

	first_block.show();
	first_link.addClass('active');
});
$('#userFile').change(function(){
	$('#j-file-loaded').show().css('opacity',1).stop().delay(3000).animate({opacity: 0},800,function(){$(this).hide();});
});
$('.col-l .text-content').children().not("script, .popup").last().each(function(){
	if ($(this).is('.boxes') || $(this).is('.gallery')) {
		$('.col-l .text-content').addClass('padding-bottom-none');
	}
});
$('.j-print').click(function(e) {
	e.preventDefault();
	window.print();
});


jQuery(function(){
	require(['maskedinput', 'tools/tools'], function () {
		maskedInput($("input[id='userPhone']"));
		$("input[id='userPhone2']").mask("ddd-dddd");
		$("input[id='userPhone1']").mask("(ddd)");
	});
});

function emailValidate(email) {
	var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
	return pattern.test(email);
}

function telValidate(tel) {
	var pattern = new RegExp(/^(\d\d\d$)/);
	return pattern.test(tel);
}

function CallTrackingWrap(el) {
	var phone = el.text();
	el.html('<span class="ad_saver_phone">' + phone + '</span>');
};
define("trash", function(){});

